import React from 'react';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {Typography} from 'components/Typography';
import style from './style.module.scss';
import {Tooltip} from 'components/Tooltip';
import Icon from 'components/Icon';

// BFF-2644: отметка особенности производства временно скрыта на новом сниппете — верните true, чтобы включить обратно
const IS_CULTIVATION_TYPE_STICKER_ENABLED = false;

type TStickersProps = Pick<IProductSnippet, 'stickers'>;

export const Stickers = (props: TStickersProps) => {
    const {stickers} = props;

    if (0 === stickers.length) {
        return null;
    }

    const alcohol = stickers.find((sticker) => 'alcohol' === sticker.code);

    return (
        <>
            <div className={style.root}>
                {stickers.map((item) => {
                    if ('cultivationType' === item.code && IS_CULTIVATION_TYPE_STICKER_ENABLED) {
                        return (
                            <Tooltip
                                key={item.code}
                                childrenClassName={style.tooltip}
                                overlay={
                                    <Typography className={style.overlay} variant={'label-12-r'}>
                                        {item.text}
                                    </Typography>
                                }
                                place={'bottom'}
                            >
                                <Icon className={style.cultivationType} icon={'organic'} />
                            </Tooltip>
                        );
                    }

                    return null;
                })}
            </div>
            {alcohol && (
                <div key={alcohol.code} className={style.alcohol}>
                    <Typography variant={'label-10-r'}>{alcohol.text}</Typography>
                </div>
            )}
        </>
    );
};
